<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading">{{ModelFor}}</h4><br>
                <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()"
                    data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="400 px" frameBorder="0" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
        Configuration - {{RepportsName}} 
    </div>

    <form [formGroup]="configReportForm" (ngSubmit)="onSubmit()">
        <div class="card rounded-4 border-0">
            <div class="card-body">
                <!-- Report Name and Group -->
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="ReportName">Report Name <span class="text-danger">*</span></label>
                            <input type="text" id="ReportName" class="form-control" formControlName="ReportName"
                                autocomplete="off" placeholder="Enter Report Name"
                                [class.is-invalid]="isFieldInvalid('ReportName')" />
                            @if (isFieldInvalid('ReportName')) {
                            <div class="text-danger">
                                @if (configReportForm.get('ReportName')?.errors?.['required']) {
                                <span>Report Name is required.</span>
                                }
                                @if (configReportForm.get('ReportName')?.errors?.['maxlength']) {
                                <span>Report Name cannot exceed 100 characters.</span>
                                }
                            </div>
                            }
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>
                                <a [routerLink]="RouteReportGroup" target="_blank">Report Group</a>
                            </label>
                            <ng-select [items]="ReportGroup" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="GroupNameReport" placeholder="Select Report Group" [clearable]="true">
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>
                                <a [routerLink]="RouteUser" target="_blank">From User <span
                                        class="text-danger">*</span></a>
                            </label>
                            <ng-select [items]="FromUserList" bindLabel="name" bindValue="id1"
                                formControlName="FromUser" placeholder="Select From User"
                                [class.is-invalid]="isFieldInvalid('FromUser')">
                            </ng-select>
                            @if (isFieldInvalid('FromUser')) {
                            <div class="text-danger">
                                @if (configReportForm.get('FromUser')?.errors?.['required']) {
                                <span>From User is required.</span>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Email and Footer -->
                <div class="row mt-3">
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Send Email On <span class="text-danger">*</span></label>
                            <ng-select [items]="emailList" [multiple]="true" formControlName="drpEmail"
                                bindLabel="Email" bindValue="ID" placeholder="Select Email Recipients"
                                [class.is-invalid]="isFieldInvalid('drpEmail')">
                                <ng-template ng-option-tmp let-item="item">
                                    {{item.UserName}} ({{item.Type}}) - {{item.Email}}
                                </ng-template>
                                <ng-template ng-selected-tmp let-item="item">
                                    {{item.UserName}} ({{item.Type}})
                                </ng-template>
                            </ng-select>
                            @if (isFieldInvalid('drpEmail')) {
                            <div class="text-danger">
                                @if (configReportForm.get('drpEmail')?.errors?.['required']) {
                                <span>At least one email recipient is required.</span>
                                }
                            </div>
                            }
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Report Footer</label>
                            <textarea class="form-control" formControlName="ReportFooter" rows="3"
                                placeholder="Enter Report Footer" maxlength="500"></textarea>
                            <small class="text-muted">
                                {{configReportForm.get('ReportFooter')?.value?.length || 0}}/500 characters
                            </small>
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <div class="row">
                            <div class="col-6">
                                <div class="">
                                    <input type="checkbox" class="" id="checkFor"
                                        formControlName="checkFor">
                                    <label class="ms-2" for="checkFor">From Date</label>
                                </div>
                                <div class=" mt-2">
                                    <input type="checkbox" class="" id="checkTo"
                                        formControlName="checkTo">
                                    <label class="ms-2" for="checkTo">To Date</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="">
                                    <input type="checkbox" class="" id="reportEnable"
                                        formControlName="reportEnable">
                                    <label class="ms-2" for="reportEnable">Enable Report</label>
                                </div>
                                <div class=" mt-2">
                                    <input type="checkbox" class="" id="sendBlankMail"
                                        formControlName="sendBlankMail">
                                    <label class="ms-2" for="sendBlankMail">Send Blank Mail</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Schedule Type Pills -->
                <div class="row mt-3">
                    <div class="col-12">
                        <label class="fw-bold small text-uppercase">Schedule Type</label>
                        <div class="d-flex gap-2 flex-wrap">
                            <button type="button" class="btn"
                                [ngClass]="{'btn-primary': ScheduleType===1, 'btn-outline-primary': ScheduleType!==1}"
                                (click)="onScheduleTypeChange(1)">
                                <i class="fa fa-clock me-1"></i>Daily
                            </button>
                            <button type="button" class="btn"
                                [ngClass]="{'btn-primary': ScheduleType===2, 'btn-outline-primary': ScheduleType!==2}"
                                (click)="onScheduleTypeChange(2)">
                                <i class="fa fa-calendar me-1"></i>Monthly
                            </button>
                            <button type="button" class="btn"
                                [ngClass]="{'btn-primary': ScheduleType===3, 'btn-outline-primary': ScheduleType!==3}"
                                (click)="onScheduleTypeChange(3)">
                                <i class="fa fa-calendar-check me-1"></i>Weekly
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Schedule Options -->
                <div class="row mt-3">
                    <div class="col-12">
                        @if (ScheduleType === 1) {
                        <div class="schedule-options p-2 bg-light rounded-2">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="small fw-bold">Select hours</span>
                                <div class="icon-toggle d-flex align-items-center gap-1 bg-light rounded-pill p-1">
                                    <button type="button" class="icon-btn" [class.active]="isAllSelected(1)"
                                        (click)="toggleAll(1)" title="Select All">
                                        <i class="fa fa fa-check-circle"></i>
                                    </button>
                                    <span class="divider">|</span>
                                    <button type="button" class="icon-btn" [class.active]="isNoneSelected(1)"
                                        (click)="toggleNone(1)" title="Select None">
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="hour-grid">
                                @for (hour of dailyHours; track hour.value) {
                                <button type="button" class="hour-btn"
                                    [class.selected]="configReportForm.get('chkDaily' + hour.value)?.value"
                                    (click)="toggleDaily(hour.value)">
                                    {{hour.label}}
                                </button>
                                }
                            </div>
                            <div class="mt-1 small text-muted text-end">{{getSelectedDailyCount()}} selected</div>
                        </div>
                        }

                        @if (ScheduleType === 2) {
                        <div class="schedule-options p-2 bg-light rounded-2">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="small fw-bold">Select days of month</span>
                                <div class="icon-toggle d-flex align-items-center gap-1 bg-light rounded-pill p-1">
                                    <button type="button" class="icon-btn" [class.active]="isAllSelected(2)"
                                        (click)="toggleAll(2)" title="Select All">
                                        <i class="fa fa fa-check-circle"></i>
                                    </button>
                                    <span class="divider">|</span>
                                    <button type="button" class="icon-btn" [class.active]="isNoneSelected(2)"
                                        (click)="toggleNone(2)" title="Select None">
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="month-grid">
                                @for (day of monthlyDays; track day.value) {
                                <button type="button" class="month-btn"
                                    [class.selected]="configReportForm.get('chkMonthly' + day.value)?.value"
                                    (click)="toggleMonthly(day.value)">
                                    {{day.label}}
                                </button>
                                }
                            </div>
                            <div class="mt-1 small text-muted text-end">{{getSelectedMonthlyCount()}} selected</div>
                        </div>
                        }

                        @if (ScheduleType === 3) {
                        <div class="schedule-options p-2 bg-light rounded-2">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="small fw-bold">Select days of week</span>
                                <div class="icon-toggle d-flex align-items-center gap-1 bg-light rounded-pill p-1">
                                    <button type="button" class="icon-btn" [class.active]="isAllSelected(3)"
                                        (click)="toggleAll(3)" title="Select All">
                                        <i class="fa fa fa-check-circle"></i>
                                    </button>
                                    <span class="divider">|</span>
                                    <button type="button" class="icon-btn" [class.active]="isNoneSelected(3)"
                                        (click)="toggleNone(3)" title="Select None">
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="week-grid">
                                @for (day of weeklyDays; track day.value) {
                                <button type="button" class="week-btn"
                                    [class.selected]="configReportForm.get('chkWeek' + day.value)?.value"
                                    (click)="toggleWeekly(day.value)">
                                    {{day.label}}
                                </button>
                                }
                            </div>
                            <div class="mt-1 small text-muted text-end">{{getSelectedWeeklyCount()}} selected</div>
                        </div>
                        }
                    </div>
                </div>

                <!-- Column Selection -->
                @if (DisplayColumn === 1) {
                <div class="row mt-3">
                    <div class="col-12">
                        <div
                            class="column-selection p-2 bg-light rounded-2 d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center gap-2">
                                <i class="fa fa-columns text-primary"></i>
                                <span class="small fw-bold">Columns</span>
                                @if (selectedColumnCount) {
                                <span class="badge bg-primary rounded-pill">{{selectedColumnCount}}</span>
                                }
                            </div>
                            <button class="btn btn-sm btn-outline-primary" (click)="openColumnSelectionModal()">
                                <i class="fa fa-edit me-1"></i>Configure
                            </button>
                        </div>
                    </div>
                </div>
                }

            </div>
        </div>
        <!-- Form Actions -->
        <div class="row mt-4">
            <div class="col-12 d-flex justify-content-center gap-3">
                @if (hasRights(['202018001', '202018021'])) {
                <button type="submit" class="btn btn-primary px-4"
                    [disabled]="configReportForm.invalid || isSaving">
                    @if (isSaving) {
                    <i class="fa fa-spinner fa-spin me-1"></i>
                    }
                    Save
                </button>
                }

                <!-- @if (hasRights(['202018001', '202018021']) && ReportDisplayID > 0) {
                <button type="button" class="btn btn-primary px-4" (click)="onSaveAs()"
                    [disabled]="configReportForm.invalid || isSaving">
                    @if (isSaving) {
                    <i class="fa fa-spinner fa-spin me-1"></i>
                    }
                    Save As
                </button>
                } -->

                <button type="button" class="btn btn-secondary px-4" (click)="resetForm()">
                  <i class="fa fa-undo me-1"></i>  Reset
                </button>
            </div>
        </div>
    </form>
</div>